/* eslint-disable max-len */
import React from "react";

import styles from "./TreeViewPage.module.css";

export type ViewIconName =
	| "bell"
	| "chevronDown"
	| "close"
	| "comment"
	| "eye"
	| "globe"
	| "heart"
	| "help"
	| "lock"
	| "logout"
	| "mail"
	| "mailOpen"
	| "pencil"
	| "people"
	| "search"
	| "send"
	| "settings"
	| "share"
	| "shield"
	| "star"
	| "starFilled"
	| "trash"
	| "tree";

type ViewIconProps = {
	name: ViewIconName;
};

const ViewIcon = ({ name }: ViewIconProps) => {
	return (
		<svg aria-hidden="true" className={styles.icon} fill="none" focusable="false" viewBox="0 0 24 24">
			{name === "heart" && (
				<path d="M20.2 6.8c-1.8-2.2-5.2-1.9-6.8.5L12 9.2l-1.4-1.9C9 4.9 5.6 4.6 3.8 6.8 1.7 9.3 2.6 13 5.2 15l6.8 5 6.8-5c2.6-2 3.5-5.7 1.4-8.2Z" />
			)}
			{name === "share" && (
				<>
					<circle cx="6" cy="12" r="2.5" />
					<circle cx="18" cy="6" r="2.5" />
					<circle cx="18" cy="18" r="2.5" />
					<path d="m8.2 10.8 7.6-3.6M8.2 13.2l7.6 3.6" />
				</>
			)}
			{name === "eye" && (
				<>
					<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
					<circle cx="12" cy="12" r="3" />
				</>
			)}
			{name === "pencil" && (
				<>
					<path d="M5 19 6.2 14.4 15.3 5.3a2 2 0 0 1 2.8 2.8L9 17.2 5 19Z" />
					<path d="m13.8 6.8 3.4 3.4" />
				</>
			)}
			{name === "globe" && (
				<>
					<circle cx="12" cy="12" r="8.5" />
					<path d="M3.8 12h16.4" />
					<path d="M12 3.5c2.2 2.3 3.4 5.1 3.4 8.5S14.2 18.2 12 20.5" />
					<path d="M12 3.5C9.8 5.8 8.6 8.6 8.6 12s1.2 6.2 3.4 8.5" />
				</>
			)}
			{name === "lock" && (
				<>
					<rect height="9" rx="2" width="13" x="5.5" y="10.5" />
					<path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" />
				</>
			)}
			{name === "people" && (
				<>
					<path d="M9 11a3.2 3.2 0 1 0 0-6.4A3.2 3.2 0 0 0 9 11Z" />
					<path d="M3.5 20c.6-3.4 2.4-5.1 5.5-5.1s4.9 1.7 5.5 5.1" />
					<path d="M16 11.2a2.8 2.8 0 1 0-.7-5.5" />
					<path d="M15.8 14.8c2.6.2 4.1 1.9 4.7 5.2" />
				</>
			)}
			{name === "comment" && (
				<path d="M20 4.5H4a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 4 16.5h3.5V20l4-3.5H20a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 20 4.5Z" />
			)}
			{name === "search" && (
				<>
					<circle cx="11" cy="11" r="6.5" />
					<path d="m16 16 4 4" />
				</>
			)}
			{name === "bell" && (
				<>
					<path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" />
					<path d="M10 19a2 2 0 0 0 4 0" />
				</>
			)}
			{name === "mail" && (
				<>
					<rect height="13" rx="2" width="18" x="3" y="5.5" />
					<path d="m3.5 7 8.5 6 8.5-6" />
				</>
			)}
			{name === "mailOpen" && (
				<>
					<path d="M3 9.8 12 4l9 5.8V19a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19Z" />
					<path d="m3.5 10.5 8.5 6 8.5-6" />
				</>
			)}
			{name === "shield" && (
				<>
					<path d="M12 3.5 5 6v5.2c0 4.3 2.9 7.5 7 9.3 4.1-1.8 7-5 7-9.3V6Z" />
					<path d="m9.3 11.8 2 2 3.4-3.6" />
				</>
			)}
			{name === "star" && (
				<path d="M12 4.5l2.3 4.7 5.2.8-3.8 3.7.9 5.1-4.6-2.4-4.6 2.4.9-5.1L4.5 10l5.2-.8L12 4.5Z" />
			)}
			{name === "starFilled" && (
				<path
					d="M12 4.5l2.3 4.7 5.2.8-3.8 3.7.9 5.1-4.6-2.4-4.6 2.4.9-5.1L4.5 10l5.2-.8L12 4.5Z"
					fill="currentColor"
					stroke="currentColor"
				/>
			)}
			{name === "trash" && (
				<>
					<path d="M4.5 7h15" />
					<path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" />
					<path d="M6.5 7l.8 11a1.5 1.5 0 0 0 1.5 1.4h6.4a1.5 1.5 0 0 0 1.5-1.4L17.5 7" />
					<path d="M10 11v5" />
					<path d="M14 11v5" />
				</>
			)}
			{name === "send" && (
				<>
					<path d="M21 4 3 11.5l6.5 2.5L12 21l9-17Z" />
					<path d="m9.5 14 4-4" />
				</>
			)}
			{name === "close" && (
				<>
					<path d="M18 6 6 18" />
					<path d="m6 6 12 12" />
				</>
			)}
			{name === "help" && (
				<>
					<circle cx="12" cy="12" r="10" />
					<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
					<path d="M12 17h.01" />
				</>
			)}
			{name === "logout" && (
				<>
					<path d="M10 6H6.8A2.8 2.8 0 0 0 4 8.8v6.4A2.8 2.8 0 0 0 6.8 18H10" />
					<path d="M14 8l-4 4 4 4" />
					<path d="M10 12h10" />
				</>
			)}
			{name === "settings" && (
				<>
					<path d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" />
					<path d="m19 13.4 1.4 1.1-2 3.5-1.8-.7a7.5 7.5 0 0 1-1.8 1.1l-.3 1.9h-4l-.3-1.9a7.5 7.5 0 0 1-1.8-1.1l-1.8.7-2-3.5L5 13.4a7.9 7.9 0 0 1 0-2.8L3.6 9.5l2-3.5 1.8.7a7.5 7.5 0 0 1 1.8-1.1l.3-1.9h4l.3 1.9a7.5 7.5 0 0 1 1.8 1.1l1.8-.7 2 3.5L19 10.6a7.9 7.9 0 0 1 0 2.8Z" />
				</>
			)}
			{/* Same glyph as LineIcon's "tree", so the entity count reads identically here and on the
			    explore cards. */}
			{name === "tree" && (
				<>
					<path d="M12 21v-8" />
					<path d="M7 17c-2.2 0-4-1.7-4-3.9 0-1.8 1.1-3.2 2.7-3.7A5.7 5.7 0 0 1 17 8.4c2.3.4 4 2.3 4 4.7 0 2.7-2.1 4.9-4.9 4.9" />
					<path d="m8.4 12.9 3.6 2.7 3.6-2.7" />
				</>
			)}
			{name === "chevronDown" && <path d="m7 10 5 5 5-5" />}
		</svg>
	);
};

export default ViewIcon;
